import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import IdentityPage from './components/IdentityPage';
import CollagePage from './components/CollagePage';
import FinalPage from './components/FinalPage';
import FloatingPetals from './components/FloatingPetals';

const T = {
  initial: { opacity: 0, y: 55, scale: 0.97 },
  animate: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.9, ease: [0.22,1,0.36,1] } },
  exit: { opacity: 0, y: -35, scale: 0.97, transition: { duration: 0.5 } },
};

export default function App() {
  const [page, setPage] = useState('identity');
  return (
    <div className="grain" style={{ position: 'relative' }}>
      <FloatingPetals />
      <AnimatePresence mode="wait">
        {page === 'identity' && <motion.div key="identity" {...T}><IdentityPage onConfirmed={() => setPage('collage')} /></motion.div>}
        {page === 'collage' && <motion.div key="collage" {...T}><CollagePage onFinished={() => setPage('final')} /></motion.div>}
        {page === 'final' && <motion.div key="final" {...T}><FinalPage /></motion.div>}
      </AnimatePresence>
    </div>
  );
}
